import Vue from "vue";

Vue.directive("waiting-animation-infinite", {

    bind(el) {
        $(el).click(event => {
            event.currentTarget.classList.add("disabled");
        });
    }
});
